/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import { InstructionPropTypes, DefaultInsructionPropTypes } from './instruction-prop-types';

type WindshieldDamageMarkingProps = InstructionPropTypes & {
  stroke?: string;
  fill?: string;
  damageColor?: string;
  animated?: boolean;
};

const AnimatedSvg = styled.svg<{ $animated: boolean }>`
  ${({ $animated }) => $animated && `
    .hand-path {
      offset-path: path('M150 103 L215.437 65.165');
      offset-distance: 0%;
      offset-rotate: 0deg;
      transform-origin: center;
      animation: moveAlongPath 4s ease-in-out infinite;
    }

    .drawing-circle {
      offset-path: path('M130 75 L195.437 37.165');
      offset-distance: 0%;
      offset-rotate: 0deg;
      animation: moveCircle 4s ease-in-out infinite;
    }

    .drawing-line {
      stroke-dasharray: 80;
      stroke-dashoffset: 80;
      animation: drawLine 4s ease-in-out infinite;
    }

    @keyframes moveAlongPath {
      0% {
        offset-distance: 0%;
      }
      100% {
        offset-distance: 100%;
      }
    }

    @keyframes moveCircle {
      0% {
        offset-distance: 0%;
      }
      100% {
        offset-distance: 100%;
      }
    }

    @keyframes drawLine {
      0% {
        stroke-dashoffset: 80;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  `}
`;

export const WindshieldDamageMarking: React.FC<WindshieldDamageMarkingProps> = ({
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  stroke,
  fill,
  damageColor,
  animated = false
}) => (
  <AnimatedSvg $animated={animated} width="295" height="210" viewBox="0 0 295 210" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke={stroke} strokeWidth={strokeWidth} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} d="M253.377 34.1833V17.9046C253.377 8.2875 245.521 0.5 235.82 0.5H67.156C57.4545 0.5 49.5986 8.2875 49.5986 17.9046V92.8686C49.5986 102.487 57.4563 110.276 67.1592 110.276H236.008M253.377 34.1833L246.42 38.7806C243.912 40.3756 242.445 43.1436 242.445 46.0991L242.445 64.5251C242.445 67.4805 243.912 70.2483 246.421 71.8433L253.377 76.4407M253.377 34.1833V76.4407M235.972 110.276C235.984 110.276 235.996 110.276 236.008 110.276M236.008 110.276C245.609 110.256 253.377 102.408 253.377 92.7194V76.4407" />
    <path fillRule="evenodd" clipRule="evenodd" d="M68.5445 109.562L68.2667 110.359H87.0061L68.5445 109.562Z" fill={fill} />
    <path d="M49.4255 18.5044C49.4255 18.5044 36.7426 27.5116 30.2118 49.2322C23.6811 70.9527 23.1605 91.782 23.0186 95.4881C22.8766 99.1942 23.2552 111.251 35.0863 116.599C46.87 121.947 62.913 127.154 65.0899 127.764C67.2668 128.374 77.3942 130.063 82.5052 121.9C87.6162 113.737 89.1779 110.453 89.1779 110.453L87.0061 110.359H68.2667L68.5445 109.562C68.5445 109.562 71.384 99.8978 70.9581 94.6905C70.5322 89.4832 65.9417 79.5847 67.74 74.0021C69.5384 68.4195 80.5176 56.1283 86.7644 49.6544C93.0112 43.1805 92.6326 35.6275 87.6162 30.7017C82.5999 25.7759 75.4539 27.2771 67.3614 33.9856C59.269 40.6941 50.1827 48.4816 50.1827 48.4816L49.4255 18.5044Z" fill={fill} />
    <path d="M68.5445 109.562C68.5445 109.562 71.384 99.8978 70.9581 94.6905C70.5322 89.4832 65.9417 79.5847 67.74 74.0021C69.5384 68.4195 80.5176 56.1283 86.7644 49.6544C93.0112 43.1805 92.6326 35.6275 87.6162 30.7017C82.5999 25.7759 75.4539 27.2771 67.3614 33.9856C59.269 40.6941 50.1827 48.4816 50.1827 48.4816L49.4255 18.5044C49.4255 18.5044 36.7426 27.5116 30.2118 49.2322C23.6811 70.9527 23.1605 91.782 23.0186 95.4881C22.8766 99.1942 23.2552 111.251 35.0863 116.599C46.87 121.947 62.913 127.154 65.0899 127.764C67.2668 128.374 77.3942 130.063 82.5052 121.9C87.6162 113.737 89.1779 110.453 89.1779 110.453L87.0061 110.359M68.5445 109.562L68.2667 110.359H87.0061M68.5445 109.562L87.0061 110.359" strokeWidth={strokeWidth} stroke={stroke} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    <path d="M182.156 50.531L191 29.5" stroke={damageColor} strokeWidth={2} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    <path d="M145.937 68.0874L148.183 76.4998" stroke={damageColor} strokeWidth={2} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    <path d="M144.112 62.0521L163.344 50.165H182.437M144.112 62.0521L145.937 68.27M144.112 62.0521L129.512 60.0404" stroke={damageColor} strokeWidth={2} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    <path d="M118 66.6246L129.792 60.041" stroke={damageColor} strokeWidth={2} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    {animated && (
      <path
        className="drawing-line"
        d="M130 75 L195.437 37.165"
        stroke={damageColor}
        strokeWidth={30}
        strokeLinecap="round"
        fill="none"
      />
    )}
    {
      !animated && (
        <circle cx="150" cy="103" r="13" fill={damageColor} />
      )
    }
    <g className="hand-path">
      <path d="M271.652 167.182C269.806 161.928 266.257 151.607 262.281 139.832C256.508 122.709 243.92 103.662 238.146 96.9067C232.372 90.1513 219.595 92.0278 214.247 92.45C208.9 92.8722 206.581 88.2279 200.807 88.2279C200.287 88.2279 199.799 88.264 199.338 88.3318C194.677 89.0165 192.791 92.9296 189.26 95.4055C185.427 98.1734 176.435 94.3265 172.413 95.4055C170.472 95.9216 168.816 97.0006 167.396 98.0796C161.678 91.0631 154.528 83.1429 148.15 76.922C143.654 72.5366 139.543 68.9956 136.588 67.211C126.035 60.784 111.648 69.6974 128.638 89.8698C129.799 91.2471 131.132 92.8287 132.594 94.5893C141.754 105.618 156.014 123.671 165.401 142.505C166.357 144.423 167.262 146.349 168.106 148.276C172.365 158.644 174.022 169.574 171.75 172.389C170.046 174.5 163.658 170.7 148.466 164.133C133.323 157.565 127.549 157.377 124.994 160.333C122.438 163.288 123.905 167.088 126.508 170.466C129.063 173.843 149.555 184.633 156.18 188.011C159.351 189.606 165.787 192.562 171.703 195.142C179.653 198.66 188.124 200.959 196.785 201.944C201.328 201.944 205.824 202.601 210.177 203.915L227.403 209.122C230.48 210.06 233.84 209.216 236.111 207.011L270.09 173.703C271.841 171.967 272.456 169.434 271.652 167.135V167.182Z" fill={fill} stroke={stroke} strokeLinecap={strokeLinecap} strokeLinejoin={strokeLinejoin} />
    </g>
  </AnimatedSvg>
);

WindshieldDamageMarking.defaultProps = {
  ...DefaultInsructionPropTypes,
  stroke: '#007BFF',
  fill: 'white',
  damageColor: '#007BFF',
  animated: false,
};
